export const SET_LIST = "polls/SET_LIST";
export const SET_POLL = "polls/SET_POLL"